export default "__VITE_ASSET__EOXGpHM5__"